//extracted by mini-css-extract-plugin
export default {"screen":"ApplicantLogin_screen__wC4dN","fields":"ApplicantLogin_fields__EOXdr","btnNext":"ApplicantLogin_btnNext__RBxus","form":"ApplicantLogin_form__1X5X3"};;